<template>
  <div class="confirmation--intro">
    <v-layout row wrap>
      <v-flex class="confirmation--intro-image" xs12 md2>
        <img :src="require('@/assets/confirmation-icon.svg')" alt="paper airplane icon" />
      </v-flex>

      <v-flex class="confirmation--intro-content" xs12 md10>
        <h2>Success!</h2>
        <p>{{heroLabel}}</p>
        <ul>
          <li v-if="companyUrl">
            <a :href="companyUrl" target="_blank">Visit our website</a>
          </li>
          <li>
            <a @click="restartWorkflow">{{scheduleAnotherLabel}}</a>
          </li>
        </ul>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import StepUtilities from '@/router/utilities/step-utilities';

const requestedStatus = 'REQUESTED';

export default {
  props: {
    companyUrl: {
      type: String,
      default: '',
    },
    status: {
      type: String,
      default: '',
    },
  },
  computed: {
    heroLabel() {
      return this.status === requestedStatus
        ? 'Your appointment has been requested. We will review and send a confirmation if the time is accepted or contact you to adjust the request.'
        : 'Your appointment has been booked. We will contact you with any questions.';
    },
    scheduleAnotherLabel() {
      return this.status === requestedStatus
        ? 'Request another appointment'
        : 'Schedule another appointment';
    },
  },
  methods: {
    restartWorkflow() {
      this.$store.dispatch('Appointment/resetBookingData');
      this.$store.commit('resetStepIndex');
      StepUtilities.goToScheduleStep(this.$router);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/mixins/breakpoints";
@import "../styles/vars/theme";
@import "../styles/vars/typography";

$_confirmation-image-size: 80px;

.confirmation--intro {
  &-content {
    font-size: 1.143rem;

    h2 {
      font-size: 1.714rem;
      letter-spacing: 0.025rem;
      margin: 0 0 0.4rem;
    }

    ul {
      list-style-type: none;
      margin: 0;
      padding: 0.1rem 0;

      li {
        padding: 0.45rem 0;

        &:first-child {
          padding-top: 0;
        }

        &:last-child {
          padding-bottom: 0;
        }

        a {
          font-size: 1rem;
          font-weight: $typography-weight-bold;
          letter-spacing: 0.03rem;
          text-decoration: none;
        }
      }
    }
  }

  &-image {
    > img {
      height: $_confirmation-image-size;
      width: $_confirmation-image-size;
    }
  }
}

@include responsive-breakpoint(sm) {
  .confirmation--intro {
    text-align: center;
  }
}
</style>
